(() => {
  const PRODUCT_GRID_SELECTOR = '#product-grid';

  function getCollectionContext() {
    const match = window.location.pathname.match(
      /^\/(?:(?<locale>[a-z]{2})\/)?collections\/(?<handle>[^/?#]+)/
    );

    if (!match) return null;

    const locale =
      match.groups?.locale ||
      document.documentElement.lang?.split('-')[0] ||
      'en';

    const collectionHandle = match.groups?.handle;

    return {
      item_list_id: `collection_${locale}_${collectionHandle}`,
      item_list_name: collectionHandle,
      collection_handle: collectionHandle,
      locale
    };
  }

  function publishSelectItem(card, link) {
    if (!window.Shopify?.analytics?.publish) return;

    const collection = getCollectionContext();

    if (!collection) return;

    const productId = card.dataset.wsProductId || '';
    const productHandle = card.dataset.wsProductHandle || '';
    const productTitle = card.dataset.wsProductTitle || '';
    const position = Number(card.dataset.wsProductPosition || 0);

    if (!productId || !productHandle) return;

    const productUrl = new URL(
      link.href,
      window.location.origin
    );

    const payload = {
      item_list_id: collection.item_list_id,
      item_list_name: collection.item_list_name,
      collection_handle: collection.collection_handle,
      locale: collection.locale,

      product_id: productId,
      product_handle: productHandle,
      item_name: productTitle,
      index: position,

      product_url: productUrl.pathname,
      source_url: window.location.pathname
    };

    Shopify.analytics.publish(
      'ws:select_item',
      payload
    );
  }

  document.addEventListener(
    'click',
    (event) => {
      if (event.__wsSelectItemHandled) return;

      const grid = event.target.closest(
        PRODUCT_GRID_SELECTOR
      );

      if (!grid) return;

      const link = event.target.closest(
        'a[href*="/products/"]'
      );

      if (!link || !grid.contains(link)) return;

      const card = link.closest(
        '[data-ws-product-id]'
      );

      if (!card) return;

      event.__wsSelectItemHandled = true;

      publishSelectItem(card, link);
    },
    true
  );
})();